import React, { useReducer, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { AsyncModel, AsyncModelClose } from '../AsyncModel/AsyncModel';
import { CusButton } from '../../Components/From/Button';
import { CusInput } from '../../Components/From/Input';
import { CusCheckbox } from '../../Components/From/Checkbox';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';
import ReactLoading from 'react-loading';
import cls from 'classnames';
import Countdown, { zeroPad } from 'react-countdown-now';
import moment from 'moment';
import { JSEncrypt } from 'jsencrypt'
import '../../Pages/pages.scss';

// api
import { postRequireVerifyCode, postCheckVerify } from '../../Api/VerifyQueue';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function OrderStep_5_verifyEmail(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    email: '',
    code: '',
    isEmailFormatCorrect: false,
    isEmailVerified: globalState.customer.verifyCodeDeadline ? true : false,
    countdownTime: 300
  });
  // 加密元件
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(window.env.REACT_APP_RSA_PUBLIC_KEY);
  let pcStyle = globalState.device === 'pc';

  return (
    <div className="Pages col d-flex flex-column align-items-center  p-0 pt-3 pt-sm-0">
      <div className="Pages__title d-flex mb-2">
        <FormattedMessage
          id="pages.takeOrder.step5_1.title"
          children={e => {
            const splitString = e.split('');
            const { langType } = globalState;
            if (langType !== 'zh' && langType !== 'ja' && langType !== 'ko') {
              const splitString = e.split(' ');
              return splitString.map((e, index) => (
                <div
                  key={index}
                  className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                >
                  <div>{e}</div>
                </div>
              ));
            } else {
              const splitString = e.split('');
              return splitString.map((e, index) => (
                <div
                  key={index}
                  className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                >
                  <div>{e}</div>
                </div>
              ));
            }
          }}
        />
      </div>
      <div className="Pages__action w-100 d-flex justify-content-center align-items-center pt-3 pb-3 mt-2 mb-2 mt-sm-3 mb-sm-3">
        <FormattedMessage
          id="pages.takeOrder.step5_1.subtitle"
          defaultMessage=""
        />
      </div>
      {/* form */}
      <div
        className="d-flex flex-column col p-0 justify-content-center mt-3 mb-3"
        style={{
          minWidth: pcStyle ? '500px' : '100%',
          maxWidth: pcStyle ? '500px' : '100%'
        }}
      >
        <div>
          {/* Email */}
          <div className="mb-4 mb-sm-5">
            <FormattedMessage
              id="pages.takeOrder.step5_1.emailInputPlaceholder"
              children={msg => {
                return (
                  <CusInput
                    className={cls('w-100')}
                    // disabled={state.isEmailStartVerifying}
                    label={
                      <FormattedMessage id="pages.takeOrder.step5_1.emailInputTitle" />
                    }
                    placeholder={msg}
                    value={state.email}
                    onChange={event => {
                      let val = event.target.value;
                      dispatch({
                        type: 'UPDATE_STATE',
                        payload: [{ key: 'email', val: val }]
                      });
                      // 錯誤Email格式
                      if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val)
                      ) {
                        dispatch({
                          type: 'UPDATE_STATE',
                          payload: [{ key: 'isEmailFormatCorrect', val: false }]
                        });
                      } else {
                        dispatch({
                          type: 'UPDATE_STATE',
                          payload: [{ key: 'isEmailFormatCorrect', val: true }]
                        });
                      }
                    }}
                  />
                );
              }}
            />
          </div>
          {/* Email button */}
          <div className="mb-4 mb-sm-5">
            <CusButton
              className="w-100 p-3"
              disabled={!state.isEmailFormatCorrect}
              children={
                <FormattedMessage id="pages.takeOrder.step5_1.buttonVerifyEmail" />
              }
              onClick={
                async () => {
                  const waittingAlert = AsyncModel({
                    content: (
                      <div className="w-100 d-flex justify-content-center">
                        <ReactLoading
                          type="spokes"
                          color="#ccc"
                          height="100px"
                          width="100px"
                        />
                      </div>
                    ),
                    showConfirmBtn: false
                  });
                  try {
                    const res = await postRequireVerifyCode({
                      email: encrypt.encrypt(state.email),
                      orderCode: globalState.customer.orderInfo.orderCode,
                      storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
                      createAt: moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD')
                    });
                    const { errCode } = res.data;
                    if (res && errCode == 200) {
                      AsyncModelClose();
                      // console.log(res.data.response.emailVerifyCode);
                      let deadLine = moment()
                        .add(5, 'm')
                        .format('x');
                      dispatchGlobal({
                        type: 'UPDATE',
                        payload: [
                          {
                            key: 'customer',
                            val: {
                              ...globalState.customer,
                              verifyCodeDeadline: deadLine
                            }
                          }
                        ]
                      });
                      dispatch({
                        type: 'UPDATE_STATE',
                        payload: [{ key: 'isEmailVerified', val: true }]
                      });
                    } else {
                      console.error('email error.');
                      dispatchGlobal({
                        type: 'UPDATE',
                        payload: [{ key: 'errMsg', val: errCode }]
                      });
                      props.history.push('/error');
                    }
                  } catch (err) {
                    console.error('email error.', err);
                    dispatchGlobal({
                      type: 'UPDATE',
                      payload: [{ key: 'errMsg', val: 410 }]
                    });
                    props.history.push('/error');
                  }
                }}
            />
          </div>
          {/* countdown */}
          {(() => {
            let deadline = globalState.customer.verifyCodeDeadline;
            if (!deadline) return null;
            return (
              <div className="Pages__space mb-4 mb-sm-5">
                <div className="Pages__space__item text-center txtColorBrown pt-3 pb-3">
                  <FormattedMessage
                    id="pages.takeOrder.step5_1.emailVerifyCountdown"
                    values={{ variable: 'pos' }}
                  />
                  <Countdown
                    date={(() => {
                      const verifyCodeDeadline =
                        globalState.customer.verifyCodeDeadline;
                      let deadLine = moment(verifyCodeDeadline, 'x').format(
                        'x'
                      );
                      let now = moment().format('x');
                      let countdownTime = deadLine - now;
                      if (countdownTime > 0) {
                        return Date.now() + countdownTime;
                      }
                    })()}
                    onComplete={() => {
                      console.log('timeout');

                      AsyncModel({
                        title: globalState.langFile['popup.timeOver'],
                        cancelBtnText: globalState.langFile['popup.buttonCancel'],
                        confirmBtnText: globalState.langFile['popup.buttonConfirm']
                      });

                      dispatch({
                        type: 'UPDATE_STATE',
                        payload: [{ key: 'isEmailFormatCorrect', val: true }]
                      });

                      dispatchGlobal({
                        type: 'UPDATE',
                        payload: [
                          {
                            key: 'customer',
                            val: {
                              ...globalState.customer,
                              verifyCodeDeadline: ''
                            }
                          }
                        ]
                      });
                    }}
                    renderer={({ minutes, seconds }) => (
                      <span>
                        {zeroPad(minutes, 2)}:{zeroPad(seconds, 2)}
                      </span>
                    )}
                  />
                </div>
              </div>
            );
          })()}
          {/* code */}
          <div className="mb-4 mb-sm-5">
            <FormattedMessage
              id="pages.takeOrder.step5_1.codeInputPlaceholder"
              children={msg => {
                return (
                  <CusInput
                    className={cls('w-100')}
                    type="tel"
                    maxLength={6}
                    label={
                      <FormattedMessage id="pages.takeOrder.step5_1.codeInputTitle" />
                    }
                    placeholder={msg}
                    value={state.code}
                    onChange={event => {
                      let val = event.target.value;
                      dispatch({
                        type: 'UPDATE_STATE',
                        payload: [{ key: 'code', val: val }]
                      });
                    }}
                  />
                );
              }}
            />
          </div>
          {/* checkbox */}
          <div className="d-flex justify-content-center justify-content-sm-start mb-4 mb-sm-5">
            <CusCheckbox
              checked={state.isSaveEmail}
              title={
                <FormattedMessage id="pages.takeOrder.step5_1.saveLogin" />
              }
              onChange={() => {
                dispatch({
                  type: 'UPDATE_STATE',
                  payload: [{ key: 'isSaveEmail', val: !state.isSaveEmail }]
                });
              }}
            />
          </div>
        </div>
        <div className="d-flex mt-3 mb-3">
          <CusButton.White
            className="col mr-2 p-3 order-step5-1-back"
            children={
              <FormattedMessage id="pages.takeOrder.step5_1.buttonBack" />
            }
            onClick={() => {
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  {
                    key: 'customer',
                    val: {
                      ...globalState.customer,
                      currentStep: '5',
                      currentQrStep: '3',
                      verifyCodeDeadline: ''
                    }
                  }
                ]
              });
            }}
          />
          <CusButton.Red
            className="col ml-2 p-3 order-step5-1-confirm"
            disabled={!state.isEmailVerified || !state.code}
            children={
              <FormattedMessage id="pages.takeOrder.step5_1.buttonConfirm" />
            }
            onClick={async () => {
              // emailVerifyC@cos.co
              const { verifyCodeDeadline } = globalState.customer;
              // 驗證碼過期
              if (!verifyCodeDeadline) {
                return AsyncModel({
                  title: globalState.langFile['errorMsg.errorCode_4103'],
                  confirmBtnText: globalState.langFile['popup.buttonConfirm']
                });
              }
              // loading
              const waittingAlert = AsyncModel({
                content: (
                  <div className="w-100 d-flex justify-content-center">
                    <ReactLoading
                      type="spokes"
                      color="#ccc"
                      height="100px"
                      width="100px"
                    />
                  </div>
                ),
                showConfirmBtn: false
              });

              try {
                const res = await postCheckVerify({
                  email: encrypt.encrypt(state.email),
                  orderCode: globalState.customer.orderInfo.orderCode,
                  emailVerifyCode: state.code,
                  storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
                  createAt: moment(globalState.customer.orderInfo.orderTime).format('YYYY/MM/DD')
                });
                const { errCode } = res.data;
                if (
                  res &&
                  errCode == 200 &&
                  globalState.customer.verifyCodeDeadline
                ) {
                  const alert = await AsyncModel({
                    title: globalState.langFile['popup.mailSuccess'],
                    confirmBtnText: globalState.langFile['popup.buttonConfirm']
                  });
                  if (!alert) return;
                  if (state.isSaveEmail) {
                    dispatchGlobal({
                      type: 'UPDATE',
                      payload: [
                        {
                          key: 'customer',
                          val: {
                            ...globalState.customer,
                            currentStep: '5',
                            currentQrStep: '3',
                            // emailAddress: state.email,
                            emailAddress: encrypt.encrypt(state.email),
                            verifyCodeDeadline: ''
                          }
                        }
                      ]
                    });
                  } else {
                    dispatchGlobal({
                      type: 'UPDATE',
                      payload: [
                        {
                          key: 'customer',
                          val: {
                            ...globalState.customer,
                            currentStep: '5',
                            currentQrStep: '3',
                            verifyCodeDeadline: ''
                          }
                        }
                      ]
                    });
                  }
                } else {
                  const alert = await AsyncModel({
                    title:
                      globalState.langFile[`errorMsg.errorCode_${errCode}`],
                    confirmBtnText: globalState.langFile['popup.buttonConfirm']
                  });
                }
              } catch (err) {
                dispatchGlobal({
                  type: 'UPDATE',
                  payload: [{ key: 'errMsg', val: 4101 }]
                });
                props.history.push('/error');
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(OrderStep_5_verifyEmail);
